import { TradingOfferOperation } from 'types';
import { TradingOfferOperationStatus } from 'types/TradingOfferOperation';

import { getOperationType } from './getOperationType';

export const isPendingForPartner = (
  operation: TradingOfferOperation,
  currentPartnerId: string
): boolean => {
  if (getOperationType(operation, currentPartnerId) !== 'BUY') return false;

  const pendingStatuses: TradingOfferOperationStatus[] = [
    TradingOfferOperationStatus.KYC_REVIEW,
    TradingOfferOperationStatus.PAYMENT_PENDING,
  ];
  return pendingStatuses.includes(operation.status);
};
